import Portal from './components/Portal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter';
import { loadAuthTokenFromCookie } from '../../shared/redux/auth/actions';
import { loadImpersonateTokenFromCookie } from '../../shared/redux/impersonate/actions';

import {
  loadVersion
} from '../../shared/redux/version/actions';


import './assets/Portal.css'

function mapStateToProps(state,props){
  return {
    pathname:props.location.pathname
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadAuthTokenFromCookie,
    loadImpersonateTokenFromCookie,
    loadVersion
  }, dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Portal));



// WEBPACK FOOTER //
// ./src/routes/Portal/index.js